export enum KlaviyoNewsletterPreferences {
  BETTING = 'Betting',
  CFB = 'CFB',
  DFS = 'DFS',
  FANTASY = 'Fantasy',
  NFL = 'NFL',
  NFL_DRAFT = 'NFL Draft',
}

export enum KlaviyoCustomProperties {
  ACCOUNT_CREATION_DATE = 'Account Creation Date',
  SUBSCRIPTION_PLAN = 'Subscription Plan',
  SUBSCRIPTION_START_DATE = 'Subscription Start Date',
  SUBSCRIPTION_END_DATE = 'Subscription End Date',
  INITIAL_SUBSCRIPTION_START_DATE = 'Initial Subscription Start Date',
  SUBSCRIPTION_STATUS = 'Subscription Status',
}

export interface NewsletterPreferences {
  betting?: boolean
  cfb?: boolean
  dfs?: boolean
  fantasy?: boolean
  nfl?: boolean
  nflDraft?: boolean
}

type ProfileAttributes = {
  email: string
  externalId: string
  firstName?: string | null
  lastName?: string | null
}

export interface IKlaviyoUserProfile extends CustomFields {
  klaviyoId: string
  attributes: ProfileAttributes
  preferences?: NewsletterPreferences
  isSubscribedToNewsletter?: boolean
}

export type CustomFields = {
  subscriptionPlan?: string
  accountCreationDate?: Date
  subscriptionStartDate?: Date
  subscriptionEndDate?: Date
  initialSubscriptionStartDate?: Date
  subscriptionStatus?: string
}

export interface ICreateKlaviyoUserProfile extends Omit<IKlaviyoUserProfile, 'klaviyoId'>, CustomFields {
  preferences: NewsletterPreferences
}
export interface IUpdateKlaviyoUserProfile extends Omit<ICreateKlaviyoUserProfile, 'klaviyoId' | 'attributes'> {
  preferences: NewsletterPreferences
  attributes?: {
    firstName?: string | null
    lastName?: string | null
  }
}

export interface IKlaviyoNewsletterSubscriptionSchema {
  subscribeToNewsletter: boolean
  newsletterPreferences: NewsletterPreferences
}

export const MARKETING_EMAILS = 'Marketing Emails'
export const LIST_OF_PREFERENCES = [MARKETING_EMAILS].concat(Object.values(KlaviyoNewsletterPreferences))
